import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import './ProductInfoPage.css';
import Navbar from '../../components/navbars/Navbar';
import ProductInfoMain from '../../components/productInfo/InfoMain/ProductInfoMain';
import BridgeOverlay from '../../components/bridgeOverlay/BridgeOverlay';
import axios from 'axios';
import ReactLoading from 'react-loading';
import { FaArrowLeft, FaArrowRight } from "react-icons/fa"; // For arrows
import CoverMaterialInfo from "../../components/productInfo/CoverMaterial/CoverMaterialInfo";
import FeatureFloat from "../../components/productInfo/FeatureFloat/FeatureFloat";
import ReactGA from 'react-ga4'



export default function ProductInfoPage() {

// GA ************************************************************************
// State *************************************
const [showOrderNow, setShowOrderNow] = useState(false);
const [data, setData] = useState({}); // Initialize as an object
const [coverTypes, setCoverTypes] = useState([]);
const [coverOptionNum, setCoverOptionsNum] = useState('')
const [coverSelection, setCoverSelection] = useState(null);  // Selected cover
const [coverImage, setCoverImage] = useState(null);  // Selected cover image URL
const [selectedCoverType, setSelectedCoverType] = useState(''); // Currently selected cover type
const [currentImageIndex, setCurrentImageIndex] = useState(0); // For the image carousel
const [loading, setLoading] = useState(false);
const { albumName, productName } = useParams();

{albumName && ReactGA.send({ hitType: "pageview", page:  `/albums/${albumName}`, title: `${albumName} view` }) }
{productName && ReactGA.send({ hitType: "pageview", page:  `/products/${productName}`, title: `${productName} view` }) }
    // Automatically rotate image every 3 seconds
    useEffect(() => {
        const interval = setInterval(() => {
            if (!loading && data.coverOptions && data.coverOptions.length > 0) {
                handleNextImage();
            }
        }, 3000);

        return () => clearInterval(interval);
    }, [data.coverOptions, currentImageIndex, loading]);

    useEffect(() => {
        const handleScroll = () => {
            const secondSection = document.getElementById('second-section');
    
            if (secondSection) {
                const rect = secondSection.getBoundingClientRect();
                const windowHeight = window.innerHeight;
    
                console.log('Scroll detected'); // Add this to check if the scroll is detected
                console.log('rect.top:', rect.top, 'windowHeight:', windowHeight);
    
                // Check if the second section is within the viewport
                if (rect.top <=  350) {
                    setShowOrderNow(true);  // Show the button when the section is visible
                } else {
                    setShowOrderNow(false);  // Hide the button when the section is not in the viewport
                }
            }
        };
    
        // Attach scroll event listener
        window.addEventListener('scroll', handleScroll);
    
        // Clean up the event listener
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    
    

    // Functions for carousel image navigation
    const handleNextImage = () => {
        if (filteredCoverOptions.length > 0) {
            setCurrentImageIndex((prevIndex) => (prevIndex + 1) % filteredCoverOptions.length);
        }
    };

    const handlePrevImage = () => {
        if (filteredCoverOptions.length > 0) {
            setCurrentImageIndex((prevIndex) =>
                prevIndex === 0 ? filteredCoverOptions.length - 1 : prevIndex - 1
            );
        }
    };

    // Filter cover options by selected cover type
    const filteredCoverOptions = Array.isArray(data?.coverOptions) 
    ? data.coverOptions.filter(option => option.coverType === selectedCoverType) 
    : [];




    // Handle cover type selection
    const handleCoverType = (coverType) => {
        if (!Array.isArray(data?.coverOptions)) {
            console.error("coverOptions is not an array or is missing.");
            return;
        }
    
        const filteredCovers = data.coverOptions.filter(option => option.coverType === coverType);
        
        if (filteredCovers.length > 0) {
            const defaultCover = filteredCovers[0];
            setCoverSelection({
                coverType: defaultCover.coverType,
                coverName: defaultCover.coverName,
                url: defaultCover.url,
            });
            setCoverImage(defaultCover.url);
            setSelectedCoverType(coverType);
        }
    };
    
    

    // Handle cover image selection
    const handleCoverImage = (url, coverName) => {
        if (data?.coverOptions) {
            const selectedCover = data?.coverOptions.find(option =>
                option.coverName === coverName && option.coverType === coverSelection.coverType
            );

            if (selectedCover) {
                setCoverSelection({
                    ...coverSelection,
                    coverName: selectedCover.coverName,
                    url: url,
                });
                setCoverImage(url);
            }
        }
    };

    // Fetch album/product data and set cover types
    useEffect(() => {
        if (!productName) {
            console.error("❌ No valid albumName or productName found. Skipping API call.");
            return;
        }
        console.log("🟢 Product Name:", productName);
        setLoading(true)
        const getData = async () => {
            try {
                let apiUrl = "";
    
                if (productName) {
                    apiUrl = `${import.meta.env.VITE_PRODUCTS_API}/products/name/${productName}`;
                }
    
                console.log("🔍 API Request URL:", apiUrl);
    
                const response = await axios.get(apiUrl);
                console.log("✅ API Response:", response.data);
    
                if (response.data) {
                    setData(response.data);
                    setCoverOptionsNum(response.data.coverOptions.length)
                }
            } catch (error) {
                console.error("❌ Error fetching data:", error);
            } finally {
                setLoading(false);
            }   
        };
    
        getData();
    }, [productName]);
    
    

    useEffect(() => {
        if (data && Object.keys(data).length) {
            console.log("Updated data:", data);
        }
    
        if (!Array.isArray(data?.coverOptions)) {
            console.error("coverOptions is not an array or is missing. Current value:", data?.coverOptions);
        }
    }, [data]);

    useEffect(() => {
        console.log( "productName:", productName);
    }, [productName]);
    

    return (
        <div >
            <Navbar />

            {/* Main Product Info Section */}
            {loading? <ReactLoading type="spin" width={80} height={80} color="dodgerblue" /> 
                :    
            <ProductInfoMain
            imageUrl={`${data?.mainImage}`}
            name={data?.albumName || data?.productName ||''}
            startingPrice={
                (Array.isArray(data?.productOptions) && data.productOptions.length > 0 ? data.productOptions[0]?.price : undefined) ||
                data?.price || ""
            }
            
            feature1={data?.productName === "Edge-Prints" ? "Pre-Mounted" : ""}
            feature1Des={data?.productName === "Edge-Prints" ? 'Ready-to-hang' : ""}
            feature2={""}
            feature2Des={""}
            feature3={coverOptionNum}
            feature3Des={"Cover Options"}
            buttonLink={`/shop/products/${productName}`}
            loading={loading}
            
            
            />
        }
            <BridgeOverlay 
                feature={"Cover Options"} 
                color={'white'}
                connectTopColor={'transparent'}
                backgroundColor={'black'} 
                connectBottomColor={'black'}
                height={'500px'}
                marginTop={'-175px'}
                marginBottom={'-50px'}
                 
            />
            <div id="second-section">
                <CoverMaterialInfo 
                    data = {data}
                    
                />
            </div>
            <BridgeOverlay 
                feature={"Construction"} 
                color={'#3c3c3c'}
                backgroundColor={'white'} 
                height={'150px'}
                marginTop={'10%'}
                marginBottom={''}
                connectTopColor={'white'}
                connectBottomColor={'white'}
                 
            />
            {productName === "Edge-Prints" &&
             <>
             <FeatureFloat 
                backgroundColor={'white'}
                imageUrl={'https://albums-and-art-product.s3.us-east-1.amazonaws.com/Edge-Prints/Edge-Prints-Cover-Options2.jpg'}
                textColor={'#3c3c3c'} 
                title={'Designer Materials'}
                description={'Select from a wide variety of fabrics or synthetic materials to match the interior of your home.'}
                reverse={false}
                />
                <FeatureFloat 
                    backgroundColor={'white'}
                    imageUrl={'https://albums-and-art-product.s3.amazonaws.com/hand-crafted/Handcrafted+Albums.png'}
                    textColor={'#3c3c3c'} 
                    title={'Made in the U.S.A'}
                    description={'Edge-Prints are printed and crafted right here in the U.S.A.'}
                    reverse={true}
                />
                <FeatureFloat 
                    backgroundColor={'white'}
                    imageUrl={'https://albums-and-art-product.s3.us-east-1.amazonaws.com/Edge-Prints/Edge-Prints-Pre-Mounted-Ready-to-Hang.jpg'}
                    textColor={'#3c3c3c'} 
                    title={'Ready-to-Hang'}
                    description={'No need to worry about any mounting, these are ready to hang out of the box.'}
                    reverse={false}
                    />
            </>
            }
            
            { productName === "edits" && 
                <FeatureFloat
                    backgroundColor={'white'}
                    imageUrl={'https://albums-and-art-product.s3.amazonaws.com/Albums/Economy/EconomyAlbum_005.jpg'}
                    textColor={'#3c3c3c'}
                    title={'Simple & Budget Friendly'}
                    description={'A simple 20-page, 8x8 or 10x10, black leather album'}

                />
            }

          

            {/* Order Now Button */}
            <div
                style={{
                    display: 'flex',
                    backgroundColor: 'transparent',
                    justifyContent: 'center',
                    alignItems: 'center',
                    position: 'fixed',
                    bottom: '25px', 
                    left: '50%', 
                    transform: 'translate(-50%)',
                    zIndex: 100
                    
                    
                }}
            >
                
                
                {productName && showOrderNow &&
                <Link to={`/shop/products/${data.productName }`}>
                    <button id="button3" style={{ width: '250px', fontSize: '16px', padding: '5px 10px', color: '#C5BAB3', border: '1px solid #C5BAB3' }}>
                        Order Now
                    </button>
                </Link>
                }
            </div>
        </div>
    );
}
